export default __webpack_public_path__ + "static/media/ruler-pencil.bcb1f0a2.svg";